import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
// import { FormsModule } from '@angular/forms';
// import { FormGroup } from '@angular/forms';

// import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { FormControlName } from '@angular/forms';
import { RoleGuardService as RoleGuard } from '../providers/authentication/role-guard.service';
import { Constantes } from '../domain/constantes';
import { Http } from '@angular/http';
import { ContenidosParentComponent } from '../views/contenidos/ContenidosParent.component';
import { ContenidosComponent } from '../views/contenidos/contenidos.component';
import { NuevoContenidoComponent } from '../views/contenidos/nuevo/nuevo.contenido.component';

import { WeditorComponent } from '../componentes/weditor/weditor.component';
import { CarrouselFotosComponent } from '../componentes/carrouselFotos/carrouselFotos.component'

import { PlanoModule } from 'interiores-mapa';
import { TranslateModule, TranslateLoader, TranslateStaticLoader  } from 'ng2-translate';
import { DraggableModule } from '../componentes/carrouselFotos/draggable/draggable.module';

import {
	AccordionModule,
	CalendarModule,
	CardModule,
	ConfirmDialogModule,
	DataGridModule,
	DialogModule,
	EditorModule,
	FileUploadModule,
	GrowlModule,
	MessagesModule,
	PanelModule,
	PickListModule,
	ToolbarModule,
	DropdownModule,
	TabMenuModule,
	PaginatorModule
} from 'primeng/primeng';
import { TableModule } from 'primeng/table';

import { FormularioWebExternaComponent } from '../formularios/FormularioWebExterna.component';
import { FormularioPosicionarContenidoComponent } from '../formularios/FormularioPosicionarContenido.component';
import { FormularioQR } from '../formularios/FormularioQR.component';
import { ImageCropperModule } from 'ngx-img-cropper';
import { Permisos } from '../providers/authentication/permisos.service';

import { ComponentesModule } from '../modules/componentes.module';

import { QRCodeModule } from 'angularx-qrcode';
import { CKEditorModule } from 'ckeditor4-angular';

/*
import { ChartModule } from 'primeng/primeng';
import { DataGridModule } from 'primeng/primeng';
import { DialogModule } from 'primeng/primeng';
import { GalleriaModule } from 'primeng/primeng';
import { PanelModule } from 'primeng/primeng';
*/
export const contenidosModuleRoutes: Routes = [
	{
		path: 'contenidos',
		component: ContenidosParentComponent, // the `component` property is necessary when the lazy module provides some service in order to injection work well. If defined, the referenced component's template should have an element with the `<router-outlet>` directive.
		children: [
			{
				path: '',
				component: ContenidosComponent,
				canActivate: [RoleGuard],
				data: {
					expectedRole: [Permisos.Contenidos_menu]
				},
				pathMatch: 'full'
			},
			{
				path: 'nuevo',
				component: NuevoContenidoComponent,
				canActivate: [RoleGuard],
				data: {
					expectedRole: [Permisos.Contenidos_menu]
				}
			},
			{
				path: 'editar',
				component: NuevoContenidoComponent,
				canActivate: [RoleGuard],
				data: {
					expectedRole: [Permisos.Contenidos_menu]
				}
			}

		],
		pathMatch: 'prefix'
	}
];

@NgModule({
	imports: [
		QRCodeModule,

		ComponentesModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule.forChild(contenidosModuleRoutes),

		PlanoModule,
/*
		ChartModule,
		DataGridModule,
		GalleriaModule,
		PanelModule,
*/

		AccordionModule,
		CalendarModule,
		CardModule,
		ConfirmDialogModule,
		DataGridModule,
		DialogModule,
		EditorModule,
		FileUploadModule,
		GrowlModule,
		ImageCropperModule,
		MessagesModule,
		PanelModule,
		PickListModule,
		TableModule,
		PaginatorModule,
		TabMenuModule,
		DropdownModule,
		ToolbarModule,
		CKEditorModule,
		DraggableModule,
		TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: function(http: Http){ return new TranslateStaticLoader(http, '/assets/i18n', '.json'); },
            deps: [Http]
        })
	],

	declarations: [
		ContenidosParentComponent,
		ContenidosComponent,
		NuevoContenidoComponent,
		CarrouselFotosComponent,
		FormularioWebExternaComponent,
		FormularioPosicionarContenidoComponent,
		WeditorComponent,
		FormularioQR
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA ]
})

export class ContenidosModule {

	static forRoot(): ModuleWithProviders {
		return {
		  ngModule: ContenidosModule
		  // providers: [CreditCardService]
		};
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/modules/contenidos.module.ts